import React from 'react';
import FooterOne from '../common/footer/FooterOne';
import HeaderOne from '../common/header/HeaderOne';
import BreadCrumbOne from '../elements/breadcrumb/BreadCrumbOne';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import SEO from '../common/SEO';

const DeleteAccount = () => {
  return (
    <>
      <SEO title="Penghapusan Akun OkePOS Owner" />
      <ColorSwitcher />
      <main className="main-wrapper">
        <HeaderOne />
        <BreadCrumbOne title="Penghapusan Akun OkePOS Owner" page="Delete Account" />
        <div className="section-padding privacy-policy-area">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="privacy-policy-content">
                  <h4>Penghapusan Akun OkePOS Owner</h4>
                  <p>
                    Pengguna OkePOS Owner dapat meminta penghapusan akun dan data terkait dengan
                    menghubungi kami melalui:
                  </p>
                  <p>
                    Email: <a href="mailto:support@ookey.id">support@ookey.id</a><br />
                    Subject: Permintaan Penghapusan Akun OkePOS Owner
                  </p>

                  <p>Mohon sertakan informasi berikut:</p>
                  <ol>
                    <li>Username akun</li>
                    <li>Nama pemilik/toko</li>
                    <li>Nomor HP atau email terdaftar</li>
                    <li>Alasan penghapusan akun, jika ada</li>
                  </ol>

                  <p>
                    Setelah permintaan diterima dan diverifikasi, kami akan memproses penghapusan akun
                    dan data terkait sesuai kebijakan privasi kami.
                  </p>

                  <p>Data yang dapat dihapus:</p>
                  <ul>
                    <li>Data akun pengguna</li>
                    <li>Data profil owner</li>
                    <li>Data toko/outlet yang terkait dengan akun</li>
                    <li>Data staff/kasir yang dibuat oleh akun tersebut, jika berlaku</li>
                  </ul>

                  <p>
                    Beberapa data transaksi atau data yang wajib disimpan untuk keperluan hukum, pajak,
                    keamanan, audit, atau penyelesaian sengketa dapat disimpan selama periode yang
                    diwajibkan oleh hukum yang berlaku.
                  </p>

                  <p>
                    Untuk bantuan lebih lanjut, hubungi{' '}
                    <a href="mailto:support@ookey.id">support@ookey.id</a>.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default DeleteAccount;
